/**
 * @generated SignedSource<<d938a9269d9c8af9f2caf04bff222990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskContactSupport_viewer$data = {
  readonly loggedInBuyerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly loggedOutBuyerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly seller?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_seller">;
  } | null;
  readonly sellerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_user">;
  } | null;
  readonly zendeskArticles: {
    readonly topicKeyForArticle: string | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskContactSupport_viewer";
};
export type GetHelpZendeskContactSupport_viewer$key = {
  readonly " $data"?: GetHelpZendeskContactSupport_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactSupport_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "useSupportChat_supportChat"
  }
],
v1 = {
  "kind": "Variable",
  "name": "sellerId",
  "variableName": "sellerId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "articleId"
    },
    {
      "kind": "RootArgument",
      "name": "hasSellerId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "isLoggedOutUser"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskContactSupport_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "loggedInBuyerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Buyer_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "supportChat(touchpoint:\"Buyer_Messaging\")"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSupportChat_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isLoggedOutUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "loggedOutBuyerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Guest_Buyer_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "supportChat(touchpoint:\"Guest_Buyer_Messaging\")"
        }
      ]
    },
    {
      "condition": "hasSellerId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "sellerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Seller_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "supportChat(touchpoint:\"Seller_Messaging\")"
        },
        {
          "alias": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSupportChat_seller"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        (v1/*: any*/)
      ],
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "articleId",
              "variableName": "articleId"
            }
          ],
          "kind": "ScalarField",
          "name": "topicKeyForArticle",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8a9830128c4f1a912512b037879a760e";

export default node;
